import { observer } from 'mobx-react-lite';
import useClosable from '../hooks/useClosable';
import { ClosableOrder } from '../store/ClosableStore';
import commonStyles from "./Common.module.css";
import Modal from "./Modal";

function EntitiesDelete({ entityName, entityCount, onCancel, onDelete }: IEntitiesDeleteProps) {
    useClosable(ClosableOrder.High, onCancel);

    return (
        <Modal header={`Delete ${entityName}?`} onClose={onCancel}>
            Are you sure you want delete {entityCount > 1 ? `these ${entityCount}` : "this"} {entityName.toLowerCase()}?
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                <button className={commonStyles.secondaryButton} onClick={onCancel}>Cancel</button>
                <button className={commonStyles.primaryButton} onClick={onDelete}>Delete</button>
            </div>
        </Modal>
    );
}

interface IEntitiesDeleteProps {
    entityName: string;
    entityCount: number;
    onCancel: () => void;
    onDelete: () => void;
}

export default observer(EntitiesDelete);
